var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"show-level-modal-page"},[_c('ModalShowLevel',{ref:"modalRef",on:{"closed":_vm.onModalClosed}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }